__turbopack_context__.v({
  "actionButton": "Actions-module-scss-module__IXEglG__actionButton",
  "actionsContainer": "Actions-module-scss-module__IXEglG__actionsContainer",
});
